import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reorder-four-sharp",
  "use": "icon-reorder-four-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-reorder-four-sharp\"><title>Reorder Four</title><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\" stroke-width=\"44\" d=\"M102 304h308M102 208h308M102 112h308M102 400h308\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol